/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const SubscriptIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="SubscriptIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M7.89844 4.46875L6.05859 7.81445L4.24219 4.46875H2.9707L5.44922 8.69922L2.90625 13H4.18945L6.08203 9.58984L7.96875 13H9.23438L6.69727 8.69922L9.17578 4.46875H7.89844Z"
                fill="currentColor"
              />
              <path
                d="M10.7227 15.0161H14.5249V14.2036H11.9922L13.103 13.2832C13.285 13.1182 13.45 12.9616 13.5981 12.8135C13.7505 12.6611 13.8817 12.5109 13.9917 12.3628C14.0975 12.2189 14.1779 12.0729 14.2329 11.9248C14.2922 11.7725 14.3218 11.6117 14.3218 11.4424C14.3218 11.2096 14.2795 11.0023 14.1948 10.8203C14.1102 10.6341 13.9896 10.4754 13.833 10.3442C13.6764 10.2131 13.486 10.1136 13.2617 10.0459C13.0374 9.97396 12.7856 9.93799 12.5063 9.93799C12.2144 9.93799 11.9499 9.98242 11.7129 10.0713C11.4801 10.1559 11.2812 10.2723 11.1162 10.4204C10.9512 10.5728 10.8242 10.7505 10.7354 10.9536C10.6465 11.1567 10.6021 11.3726 10.6021 11.6011H11.605C11.605 11.4784 11.624 11.3662 11.6621 11.2646C11.7002 11.1589 11.7573 11.07 11.8335 10.998C11.9097 10.9219 12.0049 10.8626 12.1191 10.8203C12.2376 10.778 12.3752 10.7568 12.5317 10.7568C12.6545 10.7568 12.7645 10.7738 12.8618 10.8076C12.9634 10.8415 13.048 10.8901 13.1157 10.9536C13.1834 11.0171 13.2342 11.0911 13.2681 11.1758C13.3019 11.2604 13.3188 11.3535 13.3188 11.4551C13.3188 11.5439 13.2977 11.6392 13.2554 11.7407C13.2173 11.8381 13.1538 11.946 13.0649 12.0645C13.0057 12.1449 12.9316 12.2316 12.8428 12.3247C12.7581 12.4136 12.6608 12.5088 12.5508 12.6104L10.7227 14.3306V15.0161Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

SubscriptIcon.tags = ['subscript', 'text', 'formatting', 'math', 'script'];

SubscriptIcon.category = 'General Icons';

SubscriptIcon.iconSize = 16;
